import type { FieldState } from './field-state'

export type FieldValue = string | number | boolean | null

export type FieldInputType = 'text' | 'number' | 'currency' | 'percent' | 'select' | 'date' | 'year' | 'boolean'

export interface FieldOption {
  label: string
  value: FieldValue
}

export interface FieldInputProps {
  type: FieldInputType
  label: string
  options?: FieldOption[]
  placeholder?: string
  suffix?: string
  fractionDigits?: number
  maxFractionDigits?: number
  useGrouping?: boolean
  state?: FieldState | null
}

export function isNumericFieldType(type: string): boolean {
  return type === 'number' || type === 'currency' || type === 'percent'
}

export function toDate(value: FieldValue | undefined): Date | null {
  if (value === null || value === undefined || value === '') {
    return null
  }

  const date = new Date(String(value))

  return Number.isNaN(date.getTime()) ? null : date
}

export function toYearDate(value: FieldValue | undefined): Date | null {
  const year = Number(value)

  return Number.isInteger(year) && year > 0 ? new Date(year, 0, 1) : null
}

export function toIsoDate(date: Date | null): string | null {
  if (!date) {
    return null
  }

  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  return `${date.getFullYear()}-${month}-${day}`
}
